export class Usuario {
    constructor({
      id = null,
      nomeCompleto = null,
      nomeSocial = null,
      email = null,
      cpf = null,
      perfis = Array(),
    }) {
      this.id = id;
      this.nomeCompleto = nomeCompleto;
      this.nomeSocial = nomeSocial;
      this.email = email;
      this.cpf = cpf;
      this.perfis = perfis;
    }
    static Build() {
      return new Usuario({
        id: null,
        nomeCompleto: null,
        nomeSocial: null,
        email: null,
        cpf: null,
        perfis: Array(),
      });
    }
    format() {
      this.usuarioId = this.id;
      this.perfis = this.perfis.map((p) => p.id);
      return this;
    }
  }
  